module.exports = __webpack_public_path__ + "static/thumbnail-0b524528d2359d5445eb20caf55c683b.jpg";